import React, { useState } from 'react';

import Process from './TabOrder/Process';
import Send from './TabOrder/Send';
import Accept from './TabOrder/Accept';
import Finish from './TabOrder/Finish';
import Cancel from './TabOrder/Cancel';
const TabOrder = () => {
  const [showOrder, setShowOrder] = useState(1);
  let showContentOrder = null;
  switch (showOrder) {
    case 1:
      showContentOrder = <Process />;
      break;
    case 2:
      showContentOrder = <Send />;
      break;
    case 3:
      showContentOrder = <Accept />;
      break;
    case 4:
      showContentOrder = <Finish />;
      break;
    case 5:
      showContentOrder = <Cancel />;
      break;

    default:
      return <div> Error </div>;
  }
  return (
    <div className="flex flex-col">
      <div className="flex justify-between">
        <h1 className="font-semibold text-3xl text-font-gray my-1 leading-7">
          Pesanan
        </h1>
        <button className="h-8 w-8 p-1 cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.42 34.42">
            <g
              id="Icon_feather-search"
              data-name="Icon feather-search"
              transform="translate(1.5 1.5)"
            >
              <path
                id="Path_1258"
                data-name="Path 1258"
                d="M31.877,18.188A13.688,13.688,0,1,1,18.188,4.5,13.688,13.688,0,0,1,31.877,18.188Z"
                transform="translate(-4.5 -4.5)"
                fill="none"
                stroke="#596375"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
              <path
                id="Path_1259"
                data-name="Path 1259"
                d="M32.418,32.418l-7.443-7.443"
                transform="translate(-1.619 -1.619)"
                fill="none"
                stroke="#596375"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
            </g>
          </svg>
        </button>
      </div>
      <div className="flex mt-6 mb-1 w-full">
        <div
          className={
            'px-4 mx-2 text-font-gray cursor-pointer ' +
            (showOrder === 1 ? ' progress-order relative' : ' ')
          }
          onClick={() => {
            setShowOrder(1);
          }}
        >
          Diproses
        </div>
        <div
          className={
            'px-4 mx-2 text-font-gray cursor-pointer ' +
            (showOrder === 2 ? ' progress-order relative' : ' ')
          }
          onClick={() => {
            setShowOrder(2);
          }}
        >
          Dikirim
        </div>
        <div
          className={
            'px-4 mx-2 text-font-gray cursor-pointer ' +
            (showOrder === 3 ? ' progress-order relative' : ' ')
          }
          onClick={() => {
            setShowOrder(3);
          }}
        >
          Diterima
        </div>
        <div
          className={
            'px-4 mx-2 text-font-gray cursor-pointer ' +
            (showOrder === 4 ? ' progress-order relative' : ' ')
          }
          onClick={() => {
            setShowOrder(4);
          }}
        >
          Selesai
        </div>
        <div
          className={
            'px-4 mx-2 text-font-gray cursor-pointer ' +
            (showOrder === 5 ? ' progress-order relative' : ' ')
          }
          onClick={() => {
            setShowOrder(5);
          }}
        >
          Dibatalkan
        </div>
      </div>
      <div className="w-full border border-t-8 border-background-white"></div>

      <div className="flex flex-col w-full mt-8">{showContentOrder}</div>
    </div>
  );
};

export default TabOrder;
